import "./landingPage.css";
import Header from "../common/Header";

const LandingHeader = () => {
    return (

        <Header isLandingPage={true} />
    );
};

export default LandingHeader;